import axios from 'axios';
import { Vue } from 'vue-property-decorator';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { FormElementTag } from '@/models/FormElement';

export interface IFormElementTags {
    [form: string]: {
        [id: number]: FormElementTag;
    };
}

@Module({ namespaced: true })
class FormElementTagModule extends VuexModule {
    _all: IFormElementTags = {};

    get all(): IFormElementTags {
        return this._all;
    }

    @Mutation
    add(tag: FormElementTag) {
        if (tag.form && tag.id) {
            if (!this._all[tag.form]) {
                Vue.set(this._all, tag.form, {});
            }
            Vue.set(this._all[tag.form], tag.id, tag);
        }
    }

    @Mutation
    set(tag: FormElementTag) {
        if (tag.form && tag.id) {
            Vue.set(this._all[tag.form], tag.id, tag);
        }
    }

    @Mutation
    remove(tag: FormElementTag) {
        if (tag.form && tag.id) {
            Vue.delete(this._all[tag.form], tag.id);
        }
    }

    @Mutation
    activate({ form, id }: { form: string; id: number }) {
        Vue.set(this._all[form][id], 'active', true);
    }

    @Mutation
    deactivate({ form, id }: { form: string; id: number }) {
        Vue.set(this._all[form][id], 'active', false);
    }

    @Action
    async init(form: number) {
        try {
            const r = await axios({
                method: 'GET',
                url: `/api/form_element_tags?form=${form}`,
            });

            r.data['hydra:member'].map((data: any) => {
                this.context.commit('add', new FormElementTag(data));
            });
        } catch (e) {
            return e;
        }
    }

    @Action
    async create(data: FormElementTag) {
        try {
            const r: any = await axios({
                method: 'POST',
                url: '/api/form_element_tags',
                data,
            });
            if (r.status !== 201) {
                throw Error('FormElementTag CREATE failed.');
            }
            this.context.commit('add', new FormElementTag(r.data));
        } catch (e) {
            return e;
        }
    }

    @Action
    async update(data: FormElementTag) {
        try {
            const r: any = await axios({
                method: 'PUT',
                url: `/api/form_element_tags/${data.id}`,
                data,
            });

            if (r.status !== 200) {
                throw Error('FormElementTag UPDATE failed.');
            }
            this.context.commit('set', new FormElementTag(r.data));
        } catch (e) {
            return e;
        }
    }

    @Action
    async delete(data: FormElementTag) {
        try {
            const r: any = await axios({
                method: 'DELETE',
                url: `/api/form_element_tags/${data.id}`,
            });

            if (r.status !== 204) {
                throw Error('FormElementTag DELETE failed.');
            }
            this.context.commit('remove', data);
        } catch (e) {
            return e;
        }
    }
}

export default FormElementTagModule;
